<template>
  <div v-if="shouldRenderConfig" :class="getClassName">
    <button type="button" class="btn btn-primary" @click="onDownload()">
      {{ $t("Download CF2") }}
    </button>
  </div>
</template>
<script>
import { usePackingOptionsStore } from "@/stores/modules/packingOptions";
import { mapState, mapActions } from "pinia";

export default {
  computed: {},
  methods: {
    ...mapActions(usePackingOptionsStore, ["packingDownloadCf2"]),
    onDownload: function () {
      this.packingDownloadCf2();
    }
  }
};
</script>
